import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Tabs, message, List, Divider, Typography, Image } from "antd";

import { formateDate } from "../../utils/dateUtil";
import storageUtils from "../../utils/storageUtils";
import { req_single_ams_alumni, req_edit_ams_alumni } from "../../api";
import { API_BASE } from "../../utils/contrains";
import "./alumni-single-modal.css";
const { TabPane } = Tabs;
const { Text } = Typography;

class AdumniSelfModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  static propTypes = {
    alumni: PropTypes.object.isRequired,
  };

  state = {
    loading: false,
    item: {},
  };

  // constructor(props) {
  //     super(props)
  // }

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    this.api_single_alumni();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_single_alumni = async () => {
    const { token } = this.props.user;
    const { TwId } = this.props.alumni;
    this.setState({ loading: true });
    const result = await req_single_ams_alumni(TwId, token);
    this.setState({ loading: false });
    const item = result;
    this.setState({ item });
  };

  api_edit_alumni = async (item) => {
    const result = await req_edit_ams_alumni(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      // console.log(result)
      message.success(result.message);
      this.api_single_graduateFresh();
    } else {
      message.error(result.message);
    }
  };

  ///////////////////////////////////////////////////////////

  ///////////////////////////////////////////////////////////
  render() {
    const {
      TwId,
      AlumniName,
      MobilePrincipal,
      TelephonePrincipal,
      EmailPrincipal,
      MailingAddress,
      LastFinalDegree,
      LastFinalUniversity,
      LastFinalDepartmentName,
      RecordCreateDateTime,
      PicUrl,
      Sex,
      Birthday,
      StudentId,
      LastFinalYearGrade,
      IsEmailSend,
      RemitFiveCode,
    } = this.props.alumni;
    const faceURL =
      PicUrl === ""
        ? API_BASE + "/Upload/eportfolioBanner.png"
        : API_BASE + PicUrl;

    return (
      <>
        <Text mark>申請時間：{formateDate(RecordCreateDateTime)}</Text>
        <Divider
          orientation="left"
          style={{ borderColor: "#7cb305" }}
          dashed
        ></Divider>
        <div>
          <span style={{ fontSize: "1.3em" }}>
            領取方式：
            <strong>
              {IsEmailSend === "MAIL" ? (
                <span style={{ color: "red" }}>掛號郵寄</span>
              ) : (
                <span style={{ color: "blue" }}>到校親取</span>
              )}
            </strong>
          </span>{" "}
          <br />
          <span style={{ fontSize: "1.3em" }}>
            銀行後五碼：<strong>{RemitFiveCode}</strong>
          </span>{" "}
          <br />
        </div>
        <Divider
          orientation="left"
          style={{ borderColor: "#7cb305" }}
          dashed
        ></Divider>
        <Tabs defaultActiveKey="1" type="card" className="tabsStyle">
          <TabPane
            tab={
              <span>
                <i className="fas fa-indent"></i> 基本資料
              </span>
            }
            key="1"
          >
            <List>
              <List.Item>
                <Image width={"80px"} height={"100px"} src={faceURL} /> <br />
                姓名： {AlumniName} <br />
                身份證字號： {TwId} <br />
                性別： {Sex} <br />
                生日： {Birthday} <br />
              </List.Item>
            </List>
          </TabPane>
          <TabPane
            tab={
              <span>
                <i className="fas fa-indent"></i> 通訊資料
              </span>
            }
            key="2"
          >
            <List>
              <List.Item>
                行動電話： {MobilePrincipal} <br />
                室內電話： {TelephonePrincipal} <br />
                電郵信箱： {EmailPrincipal} <br />
                通訊地址： {MailingAddress} <br />
              </List.Item>
            </List>
          </TabPane>
          <TabPane
            tab={
              <span>
                <i className="fas fa-indent"></i> 學歷資料
              </span>
            }
            key="3"
          >
            <List>
              <List.Item>
                學歷：
                {LastFinalDepartmentName !== ""
                  ? "(" +
                    LastFinalYearGrade +
                    ")  " +
                    LastFinalUniversity +
                    "/" +
                    LastFinalDepartmentName +
                    "/" +
                    LastFinalDegree
                  : ""}{" "}
                <br />
                學號：{StudentId}
              </List.Item>
            </List>
          </TabPane>
        </Tabs>
      </>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(AdumniSelfModal);
